import { Validators } from '@angular/forms';
import { ButtonType, CrudFormConfig, CrudFormSelectItem, CrudViewFormItemType } from '@rappider/rappider-components/utils';
import { PASCAL_CASE_REGEX } from '@rappider/shared/definitions';
import { METADATA_CREATE_FORM_CONFIG } from '../metadata/metadata-create-form-config';


export const PAGE_LAYOUT_CREATE_FORM_CONFIG: CrudFormConfig = {
  items: [
    {
      title: 'SHARED.TITLE',
      fieldName: 'title',
      type: CrudViewFormItemType.TextBox,
      showRequiredSign: true,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        }
      ]
    }, {
      title: 'SHARED.NAME',
      fieldName: 'name',
      showRequiredSign: true,
      type: CrudViewFormItemType.TextBox,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        },
        {
          type: Validators.pattern(PASCAL_CASE_REGEX),
          errorKey: 'pattern',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.MUST_BE_PASCAL_CASE'
        }
      ]
    },
    {
      title: 'SHARED.DESCRIPTION',
      fieldName: 'description',
      type: CrudViewFormItemType.TextArea,
    },
    METADATA_CREATE_FORM_CONFIG
  ],
  submitButton: {
    type: ButtonType.Primary
  }
};
